<style>
    .ivu-InputNumber {
        width : 50%;
        height : 100%;
        float: left;
    }
    .ivu-InputNumber .ivu-input-number-small .ivu-input-number-handler{
        height:50%;
    }
    .ivu-InputNumber .ivu-input-number-small .ivu-input-number-input-wrap{
        height:100%;
        width:100%;
    }
    .ivu-InputNumber .ivu-input-number-small input{
        height:100%;
        display:flex;
        align-items:center;
    }
    .ivu-Select {
        width : 50%;
        height : 100%;
        float: left;
    }
    .ivu-Select div{
        height:100%;
    }
    .ivu-Select .ivu-select-small.ivu-select-single .ivu-select-selection{
        height:100%; 
    }
    .ivu-Select .ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        height:100%;
        display: flex;
        align-items: center;
    }
    .ivu-fvTimeScope-div {
        position: absolute;
        padding : 0;
    }
    .scopeContent{
        width:100%;
        height:100%;
        
    }
    .ivu-select-dropdown-transfer{
        z-index: 9999 !important;
    }
</style>

<template>  
    <div
      class="ivu-fvTimeScope-div" 
      v-if="isShow"
      :style="timeScopeStyle">
        <div class="ivu-InputNumber">
            <InputNumber  :min="1" v-model="value" :disabled="isEnable" size="small" class="scopeContent"></InputNumber>
        </div>
        <div class="ivu-Select">
            <Select v-model="selected"  @on-change="getTimeType" class="scopeContent" clearable :transfer="true" size="small">
                <Option v-for="primitives in data" :value="primitives.name" :key="primitives.value" >
                {{ primitives.name }}</Option>
            </Select>
        </div>
        <!-- {{selected}} -->
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "fvTimeScope",
    props : ["primitives","parentObject"],
    created(){
        //窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        //窗口大小
        this.windowSize = this.parentObject.windowSize;
        this.create();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data(){
        return {
            isShow : true,
            isEnable : false,
            data:[],
            value:"",
            timeScopeStyle:"",
            selected:"",
        }
    },
    methods : {
        /**时间范围 */
        create() {
            this.mixin(this.primitives);
            this.windowsObject = this.$parent.$parent;
            this.workbench = this.windowsObject.workbench;
            //初始化位置
            this.timeScopeStyle = {
                left: 0 + "px",
                top: 0 + "px",
                width: 0 + "px",
                height: 0 + "px"
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }
            //设置默认时间间隔
            this.value = this.initVal;
            this.data = this.transitionUnit(this.timeUnits);
            //设置默认时间单位
            var init = [];
            init.push(this.initUnit);
            this.selected = this.transitionUnit(init)[0].name;
            this.mointer();
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },       
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        reDraw(scaleObj) {
            if(scaleObj.titleHeight != 0){
                var titleHeight = 0;
            }else{
                var titleHeight = this.y * this.frameScaleY;
            }
            this.timeScopeStyle.left = parseInt(((this.x)* (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.timeScopeStyle.top  = parseFloat(((this.y +titleHeight)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy)  + "px";
            this.timeScopeStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            if(parseInt(this.height * (scaleObj.sy + scaleObj.zoom))<18){
                this.timeScopeStyle.height = 18 + "px";
            }else{
                this.timeScopeStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            }
        },
        onTimer(){
            if(this.isEnable) return;
        },
         /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true:false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无
            作用：时间单位转化为文本显示
        */
        transitionUnit(obj){
            var temp = [];
            for (var i = 0; i < obj.length; i++) {
                switch(obj[i]){
                    case "dd":
                        temp.push(
                            {name:this.$store.state.system.$.languageName == "ch" ?"日":"day",id:this.timeUnits[i]}
                        );
                    break;
                    case "hh":
                        temp.push(
                            {name:this.$store.state.system.$.languageName == "ch" ?"时":"when",id:this.timeUnits[i]}
                        );
                    break;
                    case "mm":
                        temp.push(
                            {name:this.$store.state.system.$.languageName == "ch" ?"分":"minute",id:this.timeUnits[i]}
                        );
                    break;
                    case "ss":
                        temp.push(
                            {name:this.$store.state.system.$.languageName == "ch" ?"秒":"second",id:this.timeUnits[i]}
                        );
                    break;
                }
            }
            return temp;
        },
        /*
            参数：无
            作用：返回时间范围单位
        */
        getTimeType(){
            var index = 0;
            switch(this.selected){
                case "秒":
                    index = 0;
                break;
                case "分":
                    index = 1;
                break;
                case "时":
                    index = 2;
                break;
                case "日":
                    index = 3;
                break;
            }
            return index;
        },
        /*
            参数:无
            作用:取得控件时间 返回当前时间间隔的时间戳
            返回值:当前设置的value值 返回值为秒
        */
        GetTime(){
            var currentTime = 0;
            switch(this.selected){
                case "秒":
                    currentTime = this.value;
                break;
                case "分":
                    currentTime = this.value * 60;
                break;
                case "时":
                    currentTime = this.value * 3600;
                break;
                case "日":
                    currentTime = this.value * 86400;
                break;
            }
            return currentTime;
        },
        /*
            参数:无
            作用:取得控件时间 返回当前时间间隔的时间戳
            返回值:当前设置的value值 返回值为 毫秒
        */
        GetTime1(){
            var currentTime = 0;
            switch(this.selected){
                case "秒":
                    currentTime = this.value * 1000;
                break;
                case "分":
                    currentTime = this.value * 60 * 1000;
                break;
                case "时":
                    currentTime = this.value * 3600 * 1000;
                break;
                case "日":
                    currentTime = this.value * 86400 * 1000;
                break;
            }
            return currentTime;
        },
        /*
            参数：时间间隔数值
            作用：设置控件时间范围（默认时间单位为秒）
        */
        SetTime(Time){
            // this.selected= "分";
            // var Time = (Time/60);
            // Time = Time.toFixed(1);
            // this.value = parseFloat(Time);
            //分钟
            if( Time<3600){
                for(var i =1;i<60;i++){
                    if(Time == 60*i){
                        this.value = Time/60;
                        this.selected = "分";
                        return;
                    }
                }
            }else if(Time<86400){//小时
                for(var i =1;i<60;i++){
                    if(Time == 3600*i){
                        this.value = Time/3600;
                        this.selected = "时";
                        return;
                    }
                }
                
            }else {//天
                for(var i =1;i<365;i++){
                    if(Time == 86400*i){
                        this.value = Time/86400;
                        this.selected = "天";
                        return;
                    }
                }
            }
                this.selected = "秒";
                this.value = Time;
        },
        /*
            参数：数
            作用：设置控件时间单位
        */
        SetTimeType(nIndex){
            if(nIndex > this.data.length - 1){
                this.selected = this.data[this.data.length-1].name;
            }else{
                this.selected = this.data[nIndex].name;
            }
        },
         /*
            参数：时间间隔数值
            作用：设置时间间隔
        */
        SetTimeValue(Time){
            this.value = Time;
        },

        mointer(){
            Object.defineProperty(this,"Type",{
                set(value){
                    console.warn(this.registerName + ":Type 属性不可以直接赋值设置");
                },
                get(){
                    return this.selected;
                }
            })

            Object.defineProperty(this,"Value",{
                set(value){
                    console.warn(this.registerName + ":Value 属性不可以直接赋值设置");
                },
                get(){
                    return this.value;
                }
            })
        }
      
    }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvTimeScope/fvTimeScope.vue